import { isAnyPartnerAcceptedAuthMethod } from "src/constants/partnerConfig";
import type { AuthStage } from "src/types/auth";
import type { AuthenticationStatus } from "./AuthenticationBloc";
import type { UserData } from "./UserState";

/**
 * An assumed identity counts as fully authenticated: its session is minted from
 * an existing token, so a password-less member would otherwise land on login.
 */
export const detectAuthStage = ({
  authenticationStatus,
  userData,
  isAssumedIdentity
}: {
  authenticationStatus: AuthenticationStatus;
  userData?: Pick<
    UserData,
    "email" | "passwordSet" | "sessionAuthenticationMethod"
  >;
  isAssumedIdentity: boolean;
}): AuthStage => {
  if (authenticationStatus !== "authenticated" || !userData) {
    return "noAuth";
  }
  const { email, passwordSet, sessionAuthenticationMethod } = userData;
  if (email === undefined && passwordSet === false) {
    return "anonymous";
  }
  if (email === undefined) {
    return "partialAuth";
  }
  if (passwordSet !== false || isAssumedIdentity) {
    return "fullAuth";
  }
  return isAnyPartnerAcceptedAuthMethod(sessionAuthenticationMethod)
    ? "fullAuth"
    : "noAuth";
};
